import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  cambia_stato_prodotti,
  get_menu,
  get_prodotto_byid,
  reset_prodotto,
} from "../store/actions/ordini";
import Spinner from "../components/Spinner";
import "../style/Portate.css";
import TableMenu from "../components/TableMenu";
import { loading_login } from "../store/actions/login";
import { useState } from "react";

const Menu = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loading = useSelector((state) => state.ordini.loading);
  const listamenu = useSelector((state) => state.ordini.listamenu);
  const loading2 = useSelector((state) => state.login.loading);
  const id_ruolo = useSelector((state) => state.login.id_ruolo);

  const totalPage = useSelector((state) => state.ordini.total_page);
  const limit = useSelector((state) => state.ordini.limit);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    async function fetchportate() {
      await dispatch(loading_login(true));
      await dispatch(get_menu(currentPage, limit));
      await dispatch(loading_login(false));
    }
    fetchportate();
  }, [currentPage]);

  /* useEffect(() => {
    async function fetchportate() {
    }
    fetchportate();
  }, []); */
  const modifica = async (id) => {
    if (id != 0) {
      await dispatch(get_prodotto_byid(id));

      navigate(`../menustepper/${id}`);
    } else {
      await dispatch(reset_prodotto());
      navigate(`../menustepper/0`);
    }
  };
  const toggle = async (id, stato) => {
    if (stato == 0) {
      await dispatch(cambia_stato_prodotti(id, 1));
    } else {
      await dispatch(cambia_stato_prodotti(id, 0));
    }
    await dispatch(loading_login(true));
    await dispatch(get_menu(currentPage, limit));
    await dispatch(loading_login(false));
  };
  let itemList = [];
  const inserisciPagine = () => {
    for (let i = 1; i <= totalPage; i++) {
      if (i == currentPage) {
        itemList.push(
          <a
          key={i}

            href="#fakeLink"
            onClick={() => {
              setCurrentPage(i);
            }}
            className="btn_page actived"

          >
            {i}
          </a>
        );
      } else {
        itemList.push(
          <a
          key={i}

            href="#fakeLink"
            onClick={() => {
              setCurrentPage(i);
            }}
            className="btn_page purple"
          >
            {i}
          </a>
        );
      }
    }
    return itemList;
  };
  return (
    <div className="container-ordini margin50">
      {id_ruolo == 1 ? (
        <div className="apritavolo">
          <a
            href="#fakeLink"
            onClick={() => modifica(0)}
            className="btn purple"
          >
            Nuovo Menu
          </a>
        </div>
      ) : null}

      {loading || loading2 ? (
        <Spinner />
      ) : listamenu != 0 && totalPage != -1 ? (
        <>
          <div className="contenuto-ordini">
            <TableMenu menu={listamenu} modifica={modifica} toggle={toggle} />
          </div>
          <div className="nume-page">
            {totalPage > 0 ? inserisciPagine() : null}
          </div>
        </>
      ) : (
        "Non hai caricato alcun Menù"
      )}
    </div>
  );
};

export default Menu;
